import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { subdomain: String };

  connect() {
    if (this.widgetId) {
      window.STONLY_WID = this.widgetId;
      // On dom load
      document.addEventListener("DOMContentLoaded", this.initializeStonly);
      // Reinitialize on every Turbo navigation
      document.addEventListener("turbo:load", this.initializeStonly);
    }
  }

  get widgetId() {
    switch (this.subdomainValue) {
      case "app":
      case "post":
      case "safti":
      case "glike":
      case "immolike":
        return "68263440-33bb-11ef-a9d4-06cb0cb2a85e";
      default:
        return null;
    }
  }

  initializeStonly() {
    // Clear the previous Stonly instance
    window.StonlyWidget = null;

    // ça marche pas si c'est immédiat (voir turbo:load)
    setTimeout(() => {
      // Initialize with corrected domains and paths
      !(function (s, t, o, n, l, y, w, g, d, e) {
        s.StonlyWidget ||
          (((d = s.StonlyWidget =
            function () {
              d._api ? d._api.apply(d, arguments) : d.queue.push(arguments);
            }).scriptPath = n),
          (d.apiPath = l),
          (d.sPath = y),
          (d.queue = []),
          ((g = t.createElement(o)).async = !0),
          (e = new XMLHttpRequest()).open(
            "GET",
            n + "version?v=" + Date.now(),
            !0
          ),
          (e.onreadystatechange = function () {
            4 === e.readyState &&
              ((g.src =
                n +
                "stonly-widget.js?v=" +
                (200 === e.status ? e.responseText : Date.now())),
              (w = t.getElementsByTagName(o)[0]).parentNode.insertBefore(g, w));
          }),
          e.send());
      })(window, document, "script", "https://stonly.com/js/widget/v2/");
    }, 500);
  }
}
